<script>
    import { _ } from "../services/i18n";
    import { getClient } from '../services/session'
    import { settingsHeaderLinksStore } from "../services/header";
    import HeaderHome from "../components/HeaderHome.svelte";
    import HeaderCurrentClientInfo from "../components/HeaderCurrentClientInfo.svelte";
    import ImagePickerField from "../components/ImagePickerField.svelte";
    import {
        ImageTypes,
        saveImage,
        getImage,
        clearImage
    } from "../services/vendors";
    import { getImageUrl } from "../services/images";
    import { onMount } from "svelte";
    import { userStore } from "../services/session";

    let linksHeader = $settingsHeaderLinksStore;
    let reportLogo = "";
    let appLogo = "";
    let simulatorLogo = "";
    const imagePicked = async (evt, type) => {
        if (evt.detail?.id) {
            await saveImage(getClient(), type, evt.detail.id);
            if (type === ImageTypes.REPORT_LOGO) {
                reportLogo = getImageUrl(evt.detail);
            }
            else if (type === ImageTypes.APP_LOGO) {
                appLogo = getImageUrl(evt.detail);
            }
            else if (type === ImageTypes.SIMULATOR_LOGO) {
                simulatorLogo = getImageUrl(evt.detail);   
            }
        }
        else {
            await clearImage(evt.detail, type);
            if (type === ImageTypes.REPORT_LOGO) {
                reportLogo = "";
            }
            else if (type === ImageTypes.APP_LOGO) {
                appLogo = "";
            }
            else if (type === ImageTypes.SIMULATOR_LOGO) {
                appLogo = "";
            }
        }
    };

    onMount(async () => {
        const clientImage = await getImage(getClient(), ImageTypes.REPORT_LOGO);
        const appImage = await getImage(getClient(), ImageTypes.APP_LOGO);
        const simulatorImage = await getImage(getClient(), ImageTypes.SIMULATOR_LOGO);
        if (clientImage) {
            reportLogo = getImageUrl({ id: clientImage.imageId });
        }
        if (appImage) {
            appLogo = getImageUrl({ id: appImage.imageId });
        }
        if (simulatorImage) {
            simulatorLogo = getImageUrl({ id: simulatorImage.imageId });
        }
    });

</script>

<HeaderHome links={linksHeader} />
<HeaderCurrentClientInfo customText={$_("header_logoCurrentClientText")} />

<main>
    <header>
        <h1>{$_('logos_headerTitle')}</h1>
        <p>{$_('logos_headerDescription')}</p>
    </header>

    {#if $userStore.getAcl('reportLogo')}
        <section>
            <header>
                <h2>{$_('logos_reportLogoTitle')}</h2>
                <p>{$_('logos_reportLogoDescription')}</p>
            </header>
            <ImagePickerField on:imagePicked={evt => imagePicked(evt, ImageTypes.REPORT_LOGO)} bind:value={reportLogo} />
        </section>
    {/if}

    {#if $userStore.getAcl('appLogo')}
        <section>
            <header>
                <h2>{$_('logos_appLogoTitle')}</h2>
                <p>{$_('logos_appLogoDescription')}</p>
            </header>
            <ImagePickerField on:imagePicked={evt => imagePicked(evt, ImageTypes.APP_LOGO)} bind:value={appLogo} />
        </section>

        <section>
            <header>
                <h2>{$_('logos_simulatorLogoTitle')}</h2>
                <p>{$_('logos_simulatorLogoDescription')}</p>
            </header>
            <ImagePickerField on:imagePicked={evt => imagePicked(evt, ImageTypes.SIMULATOR_LOGO)} bind:value={simulatorLogo} />
        </section>
    {/if}
</main>

<style>
    main {
        width: 90vw;
        margin-left: auto;
        margin-right: auto;
    }

    main > header {
        margin-bottom: 40px;
    }

    section {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 15px;
        margin-bottom: 30px;
    }

    section header {
        max-width: 300px;
    }
</style>